module.exports = __webpack_public_path__ + "img/17.98f65dfc.jpg";